import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

// Import components
import BannerImage from './BannerImage';

// Import utilities
import { Slider } from 'components/utilities';
import useBannerLogic from './useBannerLogic';

// Import helpers
import { getImage } from 'helpers';
import { sendBannerEvent } from 'helpers/tracking';

// Import variables
import { PRODUCT_IMAGES_TYPES, DEFAULT_SLIDER_DELAY } from 'helpers/variables';

const { COVER } = PRODUCT_IMAGES_TYPES;

const Banners = ({ items }) => {
	const settings = {
		dots: false,
		infinite: true,
		speed: 500,
		autoplaySpeed: DEFAULT_SLIDER_DELAY,
		swipe: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		adaptiveHeight: true
	};

	const { containerRef, bannerHeight } = useBannerLogic();

	const imageSize = '=w1920-h400-c';

	const getCoreDomain = (url) => url.replace(/^https?:\/\//g, '').split(/\//);

	const renderBanners = ({ uuid, images, title, context: { url_pc } }) => {
		const coverUrl = getImage({ images, types: [COVER] });

		if (!coverUrl) return null;

		const url = getCoreDomain(window.location.href);
		const urlPc = getCoreDomain(url_pc);

		const isExternalPath = url[0] === urlPc[0];
		const externalPathUrl = `/${urlPc.splice(1).join('/')}`;

		const bannerImage = `${coverUrl}${imageSize}`;

		const handleLinkClick = () => {
			const destinationPath = isExternalPath ? externalPathUrl : url_pc;

			sendBannerEvent(title, destinationPath);
		};

		return (
			<SliderItem key={uuid}>
				{url_pc ? (
					<>
						{isExternalPath ? (
							<Link to={externalPathUrl} onClick={handleLinkClick}>
								{renderBannerImage({ bannerImage, title })}
							</Link>
						) : (
							<a href={url_pc} target="_blank" rel="noopener noreferrer" onClick={handleLinkClick}>
								{renderBannerImage({ bannerImage, title })}
							</a>
						)}
					</>
				) : (
					renderBannerImage({ bannerImage, title })
				)}
			</SliderItem>
		);
	};

	const renderBannerImage = ({ bannerImage, title }) => <BannerImage bannerImage={bannerImage} title={title} bannerHeight={bannerHeight} />;

	return (
		<BannersSliderWrap ref={containerRef}>
			<Slider defaultBtn={false} settings={settings}>
				{items.map(renderBanners)}
			</Slider>
		</BannersSliderWrap>
	);
};

const BannersSliderWrap = styled.div`
	.slick-slider {
		.button {
			height: 100%;
			bottom: 0;
		}
	}
`;

const SliderItem = styled.div`
	display: block !important;
`;

Banners.propTypes = {
	items: PropTypes.array.isRequired
};

export default Banners;
